import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Calendar from "react-calendar";
import { useMerchant } from "../../context/merchant";
import "../../css/calendar.css";

export default function CalendarModal({
  show,
  handleClose,
  selectedModal,
  setStartDate,
  setEndDate,
}) {
  const { isFullScreen } = useMerchant();
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleSubmit = () => {
  const y = selectedDate.getFullYear();
  const m = String(selectedDate.getMonth() + 1).padStart(2, "0");
  const d = String(selectedDate.getDate()).padStart(2, "0");
  const dateOnly = `${y}-${m}-${d}`; // ✅ local YYYY-MM-DD

  selectedModal === "start" && setStartDate(dateOnly);
  selectedModal === "end" && setEndDate(dateOnly);

  handleClose();
};

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      //   onExited={() => setSelectedDate(new Date())}
    >
      <Modal.Header closeButton className="bg-primary">
        <div
          className={`${isFullScreen ? "h3" : "h4"} header-title text-white`}
        >
          {selectedModal === "start" && "Эхлэх огноо сонгох"}
          {selectedModal === "end" && "Дуусах огноо сонгох"}
        </div>
      </Modal.Header>

      <Modal.Body>
        <Calendar
          className={isFullScreen && "fullScreenText"}
          maxDate={new Date()}
          nextLabel={
            <div className="btn btn-sm">
              <i className="ri-arrow-right-s-line fs-3" />
            </div>
          }
          prevLabel={
            <div className="btn btn-sm">
              <i className="ri-arrow-left-s-line fs-3" />
            </div>
          }
          next2Label={null}
          prev2Label={null}
          onChange={setSelectedDate}
          value={selectedDate}
        />
      </Modal.Body>

      <Modal.Footer>
        <div
          className={`btn btn-outline-primary ${isFullScreen && "btn-lg"}`}
          onClick={handleClose}
        >
          Болих
        </div>
        <Button
          className={`btn btn-primary ${isFullScreen && "btn-lg"}`}
          onClick={handleSubmit}
        >
          Сонгох
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
